import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";

import { GET_REMEDIATION_LANGUAGES } from "../../vulnerability-modal/queries";
import type {
  IUseRemediationLanguagesProps,
  IUseRemediationLanguagesResult,
} from "../types";
import { useAudit } from "hooks/use-audit";
import { Logger } from "utils/logger";
import { msgError } from "utils/notifications";

const useRemediationLanguages = ({
  groupName,
  remediationId,
}: IUseRemediationLanguagesProps): IUseRemediationLanguagesResult => {
  const { t } = useTranslation();
  const { addAuditEvent } = useAudit();

  const { data, loading } = useQuery(GET_REMEDIATION_LANGUAGES, {
    onCompleted: (): void => {
      addAuditEvent("RemediationLanguages", remediationId);
    },
    onError: ({ graphQLErrors }): void => {
      msgError(t("groupAlerts.errorTextsad"));
      Logger.warning(
        "An error occurred loading remediation languages",
        graphQLErrors,
      );
    },
    variables: {
      groupName,
      vulnerabilityId: remediationId,
    },
  });

  return {
    languages: data?.remediationLanguages.fixes ?? [],
    loading,
  };
};

export { useRemediationLanguages };
